import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import storage from 'redux-persist/lib/storage';
import { POSStationsSlice } from '@modules/point-of-sale/slice/pos-stations.slice';
import { POSTableAreaSlice } from '@modules/point-of-sale/slice/pos-table-area.slice';
import { POSDisplayGroupingSlice } from '@modules/point-of-sale/slice/pos-group-display';
import localforage from 'localforage';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { mfaLoginResetTransform, UserSlice } from '../store/slices/user.slice';
import { ACCGAccountingPeriodSlice } from './slices/accounting-and-finance/accg-accounting-period.slice';
import { ACCGChartOfAccountsSlice } from './slices/accounting-and-finance/accg-chart-of-accounts.slice';
import { ACCGCurrencyListSlice } from './slices/accounting-and-finance/accg-currency-list.slice';
import { ACCGCurrencyOptionsSlice } from './slices/accounting-and-finance/accg-currency-options.slice';
import { ACCGDefaultMappingListSlice } from './slices/accounting-and-finance/accg-default-mapping-list.slice';
import { ACCGDefaultMappingUnmappedSlice } from './slices/accounting-and-finance/accg-default-mapping-unmapped.slice';
import { ACCGProductsServices } from './slices/accounting-and-finance/accg-products-services.slice';
import { ACCGProfitAndCostListSlice } from './slices/accounting-and-finance/accg-profit-and-cost-list.slice';
import { ACCGProjectsSlice } from './slices/accounting-and-finance/accg-projects.slice';
import { ACCGSuppliersSlice } from './slices/accounting-and-finance/accg-suppliers.slice';
import { ACCGTaxCodeSlice } from './slices/accounting-and-finance/accg-tax-code.slice';
import { ConfigurationSlice } from './slices/configuration.slice';
import { DisclosureSlice } from './slices/disclosure.slice';
import { FilesDescriptionSlice } from './slices/files-description.slice';
import { FOBookingAccountsListType } from './slices/front-office/fo-booking-accounts-list.slice';
import { FOBookingOptionListSlice } from './slices/front-office/fo-booking-option-list.slice';
import { FOCalendarFiltersSlice } from './slices/front-office/fo-calendar-filters.slice';
import { FOConfigurationSlice } from './slices/front-office/fo-configuration.slice';
import { NationalityListSlice } from './slices/nationality-list.slice';
import { APISlice } from './slices/api.slice';
//import { POSOrderWindowSlice } from './slices/point-of-sale/pos-order-window.slice';
//import { POSSelectionSlice } from './slices/point-of-sale/pos-selection.slice';

import { filesApi } from '../api/files.api.rtk';
import { roomConfigApi } from '../api/front-office/fo-room-config.api.rtk';
import { userManagementApi } from '../api/users-management/user-mangement.api.rtk';
import { api } from '../services/api';
import { GuideSlice } from './slices/guide.slice';
import { PropertiesSlice } from './slices/property.slice';

import { channelManagerApi } from '../api/channel-manager/channel-manager.api.rtk';
import { chargingStationApi } from '../api/front-office/charging-station.api.rtk';
import { logsApi } from '../api/front-office/logs.api.rtk';
import { preApprovedApi } from '../api/front-office/pre-approved.api.rtk';
import { presetRecurringApi } from '../api/front-office/preset-recurring.api.rtk';
import { reportsApi } from '../api/front-office/reports.api.rtk';
import { notificationApi } from '../api/notification/notification.api.rtk';
import { tracesApi } from '../api/traces/traces.api.rtk';
import { rtkKey } from '../utils/url';

import { casApi } from '../api/cas/cas.api.rtk';
import { netLockApi } from '../api/front-office/netlock.api.rtk';
import { keyApi } from '../api/key/key.api.rtk';

import { clAccountsApi } from '@api/front-office/cl-accounts.api.rtk';
import { propertyApi } from '@api/property.api.rtk';
import { xenditAPI } from '@api/xendit.api';
import { POSMasterlistSlice } from '@modules/point-of-sale/slice/pos-masterlist.slice';
import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/dist/getDefaultMiddleware';
import { ACCGCustomerSlice } from '@store/slices/accounting-and-finance/accg-customer.slice.ts';
import { ACCGProjectSlice } from '@store/slices/accounting-and-finance/accg-projects-slice.ts';
import {
  createStateSyncMiddleware,
  initMessageListener,
} from 'redux-state-sync';
import { profitAndCostApi } from '../api/accounting-and-finance/profit-and-cost.api.rtk';
import { databaseApi } from '../api/database.api';
import { ACCGSelectedAccountingPeriodSlice } from './slices/accounting-and-finance/accg-selected-accounting-period.slice';
import { ACCGCheckBookSlice } from './slices/accounting-and-finance/check-book.slice';
import { CurrencySlice } from './slices/currency-list.slice';
import { FOEntriesManagementSlice } from './slices/front-office/fo-entries-management.slice';
import { FOInitialSetupSlice } from './slices/front-office/fo-initial-setup.slice';
import { SubscriptionSlice } from './slices/subscription.slice';
import { templateHistoryReducer } from './slices/pdf/react-pdf.slice';
import { GenparSlice } from './slices/genpar.slice';
import { InitialSetupSlice } from './slices/initial-setup.slice';
//import { TemplateSlice } from './slices/pdf/react-pdf.slice';
import { KeyboardSlice } from './slices/keyboard.slice';
import { AppSlice } from './slices/app.slice';
import { ACCGStationsSlice } from './slices/accounting-and-finance/accg-stations.slice';

export const persistKey = 'servo-v1';

const normalizeDisclosureState = (state: any) => {
  if (!state?.disclosure) return state;

  const protectedRoute = state.disclosure.protectedRoute;

  if (
    protectedRoute &&
    typeof protectedRoute === 'object' &&
    !Array.isArray(protectedRoute)
  ) {
    return state;
  }

  return {
    ...state,
    disclosure: {
      ...state.disclosure,
      protectedRoute: {},
    },
  };
};

// Default configuration for migrations
const migrations = {
  0: (state: any) => {
    return {
      ...state,
      settings: {
        ...state.settings,
        moodColorCategory: {
          colorPalette: 'DEFAULT',
        },
      },
    };
  },
  2: normalizeDisclosureState,
};

// List of reducers. Limit the number of reducers to the number of modules available. ADD ONLY IF NEW MODULE WAS ADDED
const reducerSlices = {
  disclosure: DisclosureSlice.reducer,
  configuration: ConfigurationSlice.reducer,
  user: UserSlice.reducer,
  properties: PropertiesSlice.reducer,
  guide: GuideSlice.reducer,
  currency: CurrencySlice.reducer,
  foConfiguration: FOConfigurationSlice.reducer,
  accgCheckBook: ACCGCheckBookSlice.reducer,
  accgCurrencyList: ACCGCurrencyListSlice.reducer,
  accgCurrencyOptions: ACCGCurrencyOptionsSlice.reducer,
  accgAccountingPeriod: ACCGAccountingPeriodSlice.reducer,
  selectedAccountingPeriod: ACCGSelectedAccountingPeriodSlice.reducer,
  accgProject: ACCGProjectsSlice.reducer,
  accgChartOfAccount: ACCGChartOfAccountsSlice.reducer,
  accgProfitAndCostList: ACCGProfitAndCostListSlice.reducer,
  accgTaxCode: ACCGTaxCodeSlice.reducer,
  accgDefaultMappingList: ACCGDefaultMappingListSlice.reducer,
  accgDefaultMappingUnmappedEntries: ACCGDefaultMappingUnmappedSlice.reducer,
  accgSuppliers: ACCGSuppliersSlice.reducer,
  accgProductsServices: ACCGProductsServices.reducer,
  accgCustomers: ACCGCustomerSlice.reducer,
  accgProjects: ACCGProjectSlice.reducer,
  accgStations: ACCGStationsSlice.reducer,
  foBookingOptionList: FOBookingOptionListSlice.reducer,
  foBookingAccountsList: FOBookingAccountsListType.reducer,
  foCalendarFilters: FOCalendarFiltersSlice.reducer,
  foInitialSetup: FOInitialSetupSlice.reducer,
  nationalityList: NationalityListSlice.reducer,
  filesDescription: FilesDescriptionSlice.reducer,
  posStations: POSStationsSlice.reducer,
  posTableArea: POSTableAreaSlice.reducer,
  posDisplayGrouping: POSDisplayGroupingSlice.reducer,
  posMasterlist: POSMasterlistSlice.reducer,
  foEntriesManagement: FOEntriesManagementSlice.reducer,
  keyboard: KeyboardSlice.reducer,
  subscription: SubscriptionSlice.reducer,
  template: templateHistoryReducer,
  genpar: GenparSlice.reducer,
  initialSetup: InitialSetupSlice.reducer,
  apiSlice: APISlice.reducer,
  app: AppSlice.reducer,
  [api.reducerPath]: api.reducer,
  [filesApi.reducerPath]: filesApi.reducer,
  [userManagementApi.reducerPath]: userManagementApi.reducer,
  [chargingStationApi.reducerPath]: chargingStationApi.reducer,
  [presetRecurringApi.reducerPath]: presetRecurringApi.reducer,
  [tracesApi.reducerPath]: tracesApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [logsApi.reducerPath]: logsApi.reducer,
  [preApprovedApi.reducerPath]: preApprovedApi.reducer,
  [channelManagerApi.reducerPath]: channelManagerApi.reducer,
  [databaseApi.reducerPath]: databaseApi.reducer,
  [casApi.reducerPath]: casApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [keyApi.reducerPath]: keyApi.reducer,
  [netLockApi.reducerPath]: netLockApi.reducer,
  [profitAndCostApi.reducerPath]: profitAndCostApi.reducer,
  [xenditAPI.reducerPath]: xenditAPI.reducer,
  [propertyApi.reducerPath]: propertyApi.reducer,
};

const persistConfig = {
  key: persistKey,
  storage: localforage,
  version: 2,
  timeout: 0,
  // storage,
  whitelist: Object.keys(reducerSlices),
  // whitelist: Object.keys(reducerSlices).filter((key) => key !== 'template'),
  migrate: createMigrate(migrations),
  transforms: [
    mfaLoginResetTransform,
    encryptTransform({
      secretKey: rtkKey,
      onError: (err) => console.log(err),
    }),
  ],
};

const reducers = combineReducers(reducerSlices);

const reducer = persistReducer<ReturnType<typeof reducers>>(
  persistConfig,
  reducers,
);

const middleware = (getDefaultMiddleware: CurriedGetDefaultMiddleware) => {
  return getDefaultMiddleware({
    // serializableCheck: {
    //   ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    // },
    immutableCheck: false,
    serializableCheck: false,
  }).concat(
    api.middleware,
    filesApi.middleware,
    userManagementApi.middleware,
    roomConfigApi.middleware,
    chargingStationApi.middleware,
    presetRecurringApi.middleware,
    tracesApi.middleware,
    reportsApi.middleware,
    logsApi.middleware,
    preApprovedApi.middleware,
    channelManagerApi.middleware,
    databaseApi.middleware,
    casApi.middleware,
    notificationApi.middleware,
    keyApi.middleware,
    netLockApi.middleware,
    profitAndCostApi.middleware,
    xenditAPI.middleware,
    clAccountsApi.middleware,
    propertyApi.middleware,
    ...[
      createStateSyncMiddleware({
        blacklist: [
          'persist/FLUSH',
          'persist/REHYDRATE',
          'persist/PAUSE',
          'persist/PERSIST',
          'persist/PURGE',
          'persist/REGISTER',
        ],
        predicate: (action) => {
          const type = action?.type;
          if (
            type?.includes('/pending') ||
            type?.includes('/fulfilled') ||
            type?.includes('/rejected')
          ) {
            return false;
          }
          return true;
        },
      }),
    ],
  );
};

export const store = configureStore({
  reducer,
  middleware,
});

initMessageListener(store);

export const setupStore = (preloadedState?: Partial<SetupRootState>) => {
  return configureStore({
    reducer,
    middleware,
    preloadedState,
  });
};

export const persistor = persistStore(store);
export type SetupRootState = ReturnType<typeof store.getState>;
export type RootState = ReturnType<typeof reducers>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
